module.exports = __webpack_public_path__ + "static/media/clock.790454a7.svg";